// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 379) return "static/chunks/379-517a0bb35945d655.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"95":"7616def2","160":"db989501","185":"5b182311","801":"84625206","925":"c03e3c83"}[chunkId] || chunkId) + "." + {"95":"758ff6d290ce21c4","160":"cb8d73af35ebe030","185":"8c2807729c98ec30","314":"b47cc404e1975f3b","329":"6f16075a9740b336","596":"1e407476fb583952","801":"d1e3ce8cc9e1dd37","925":"cf206209438285aa"}[chunkId] + ".js";
};